import { BikeleasingContractListItemDTOStatusEnum } from '../api';

export const ACTIVE_BIKELEASING_CONTRACT_STATUSES: BikeleasingContractListItemDTOStatusEnum[] = [
  BikeleasingContractListItemDTOStatusEnum.Active,
  BikeleasingContractListItemDTOStatusEnum.Expiring,
  BikeleasingContractListItemDTOStatusEnum.BikeTransferDone,
  BikeleasingContractListItemDTOStatusEnum.BikeShipped,
  BikeleasingContractListItemDTOStatusEnum.BikeTransferRequired,
];

export const INACTIVE_BIKELEASING_CONTRACT_STATUSES: BikeleasingContractListItemDTOStatusEnum[] = [
  BikeleasingContractListItemDTOStatusEnum.Finished,
  BikeleasingContractListItemDTOStatusEnum.CancelledOrRejected,
  BikeleasingContractListItemDTOStatusEnum.EmployerApprovalRequired,
  BikeleasingContractListItemDTOStatusEnum.Requested,
  BikeleasingContractListItemDTOStatusEnum.EmployeeApprovalRequired,
  BikeleasingContractListItemDTOStatusEnum.EmployerApprovalDone,
];

export const ALL_BIKELEASING_CONTRACT_STATUSES = [...ACTIVE_BIKELEASING_CONTRACT_STATUSES, ...INACTIVE_BIKELEASING_CONTRACT_STATUSES];

const ALL_BIKELEASING_CONTRACT_STATUSES_SET = new Set<string>(ALL_BIKELEASING_CONTRACT_STATUSES);

export function isBikeleasingContractStatus(contractStatus: string): contractStatus is BikeleasingContractListItemDTOStatusEnum {
  return ALL_BIKELEASING_CONTRACT_STATUSES_SET.has(contractStatus as BikeleasingContractListItemDTOStatusEnum);
}
